export enum EnumNewsType {
  BLOG = 1,
  MEDIA = 2,
  SOCIAL = 3,
}

export const enum EnumNewsStatus {
  /** 上架  */
  ON = 2,
  /** 下架  */
  OFF = 1,
}
